import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './warranty.actions';

@Injectable()
export class WarrantyPageEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);

    loadWarranty$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadPageWarranty),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.dealerApi.getPageWarranty(dealerSlug)).pipe(
                    map((content) => actions.loadPageWarrantySuccess({ content })),
                    catchError((error) => of(actions.loadPageWarrantyFailure({ error }))),
                ),
            ),
        );
    });
}
